import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject, signal, WritableSignal } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { convertRequestStatus } from "app/modules/manage/workflow/task/workflow-task.util";
import { UtilCommon } from "app/shared/common/utils/UtilCommon";

@Component({
  selector: "app-aggrid-group-cell",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./aggrid-group-cell.component.html",
  styleUrl: "./aggrid-group-cell.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AggridGroupCellComponent implements ICellRendererAngularComp {

  public params: ICellRendererParams;

  public getPadding: WritableSignal<string> = signal<string>("0px");
  public urgentLabel: WritableSignal<string> = signal<string>("(0 / 10 / 5)");
  public getKey: WritableSignal<string> = signal<string>("");
  readonly translocoService: TranslocoService = inject(TranslocoService);

  agInit(params: ICellRendererParams): void {
    this.params = params;
    if (params.node?.level > 0) {
      this.getPadding.set(`0 0 0 ${params.node.level * 15}px`);
    }

    let key = params.node.key;
    if (params?.node?.field?.toLowerCase().includes('aggstatus') && key) {
      const formatted = key
        .split(', ') // Split string by comma and space
        .map(word =>
          UtilCommon.capitalizeFirstCharacterOfWords(convertRequestStatus(word, this.translocoService))
        )
        .join(', '); // Join back into a string
      key = formatted;
    } else if (params?.node?.field?.toLowerCase().includes('status') && key) {
      key = UtilCommon.capitalizeFirstCharacterOfWords(key);
    }

    // this.getKey.set(this.#formatKey(params.node?.key) ?? "undefined");
    this.getKey.set(this.#formatKey(key) ?? "");

    if (this.params.data) {
      this.urgentLabel.set(
        `(${this.params.data?.remainLevel1Sum || 0} / ${this.params.data?.remainLevel2Sum || 0} / ${this.params.data?.remainLevel3Sum || 0})`
      );
    }
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

  #formatKey(key: any) {
    if (!key) return key;

    if (typeof key == "string" && key?.includes("@")) {
      return key.split(",")?.[0]?.split("@")?.[0];
    } else if (key != null && typeof key == "object") {
      // return key?.name ? UtilCommon.getLabelLanguage(key?.name) : "undefined";
      return key?.name ? UtilCommon.getLabelLanguage(key?.name) : "";
    }
    return key;
  }

  toggleGroup() {
    this.params.node.setExpanded(!this.params.node.expanded);
  }
}
